'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dCredentials$002dPage from "./presto.-List-Credentials-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_ListCredentialsPage$() {
}
export { $c_Lpresto_ListCredentialsPage$ as $c_Lpresto_ListCredentialsPage$ };
$p = $c_Lpresto_ListCredentialsPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListCredentialsPage$;
/** @constructor */
function $h_Lpresto_ListCredentialsPage$() {
}
export { $h_Lpresto_ListCredentialsPage$ as $h_Lpresto_ListCredentialsPage$ };
$h_Lpresto_ListCredentialsPage$.prototype = $p;
$p.l = (function() {
  return "ListCredentialsPage";
});
$p.cGd = (function(x$0) {
  return new $j_presto$002e$002dList$002dCredentials$002dPage.$c_Lpresto_ListCredentialsPage(x$0.j(0));
});
var $d_Lpresto_ListCredentialsPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListCredentialsPage$, "presto.ListCredentialsPage$", ({
  KG: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_ListCredentialsPage$ as $d_Lpresto_ListCredentialsPage$ };
var $n_Lpresto_ListCredentialsPage$;
function $m_Lpresto_ListCredentialsPage$() {
  if ((!$n_Lpresto_ListCredentialsPage$)) {
    $n_Lpresto_ListCredentialsPage$ = new $c_Lpresto_ListCredentialsPage$();
  }
  return $n_Lpresto_ListCredentialsPage$;
}
export { $m_Lpresto_ListCredentialsPage$ as $m_Lpresto_ListCredentialsPage$ };
//# sourceMappingURL=presto.-List-Credentials-Page$.js.map
